import React from 'react';

interface FadeTransitionProps {
  height?: string;
  backgroundColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

const FadeTransition: React.FC<FadeTransitionProps> = ({
  height = '66px',
  backgroundColor = '#ffffff',
  className = '',
  style = {},
}) => {
  return (
    <div style={{ position: 'relative', width: '100%', ...style }} className={className}>
      <div
        style={{
          pointerEvents: 'none',
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          height,
          background: `linear-gradient(to bottom, rgba(255,255,255,0), ${backgroundColor} 90%)`,
        }}
      />
    </div>
  );
};

export default FadeTransition;
